import { render, staticRenderFns } from "./TaktNews.view.vue?vue&type=template&id=f0db3d9a&scoped=true&lang=html&"
import script from "./TaktNews.view.vue?vue&type=script&lang=js&"
export * from "./TaktNews.view.vue?vue&type=script&lang=js&"
import style0 from "./TaktNews.view.vue?vue&type=style&index=0&id=f0db3d9a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0db3d9a",
  null
  
)

export default component.exports